// Angular
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule} from '@angular/forms';
// Angular/material
import {MatListModule} from '@angular/material/list';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';

// Afidium
import {RouterModule} from "@angular/router";
import {NotificationModule} from "libraries/component/notification/notification.module";
import {LoaderModule} from 'libraries/component/loader/loader.module';
import {BtnModule} from "libraries/ui_button/btn.module";
import {ProcessingComponent} from "./processing.component";
import {PipesModule} from "libraries/pipes/pipes.module";
import {HelperService} from "app_sasha/shared/services/helper.service";
import {DatePipeModule} from "libraries/date/date.module";
import { ProcessingStatusModule } from 'app_sasha/shared/components/processing-status/processing-status.module';
import {PermissionModule} from "libraries/permission/permission.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";

@NgModule({
    imports: [
        CommonModule,
        MatListModule,
        MatCheckboxModule,
        MatSlideToggleModule,
        FormsModule,
        NotificationModule,
        LoaderModule,
        BtnModule,
        PipesModule,
        DatePipeModule,
        RouterModule,
        ProcessingStatusModule,
        PermissionModule,
        FontAwesomeModule,
    ],
    exports: [
        ProcessingComponent,
    ],
    declarations: [
        ProcessingComponent,
    ],
    providers: [
        HelperService
    ],
})
export class ProcessingModule {
}
